<template>
  <div class="mapDiv">
    <div id="container"></div>
  </div>
</template>

<script>
// import AMap from 'AMap'
export default {
  props: {},
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},

  mounted() {
    this.init();
    //  var map = new AMap.Map('container', {
    //         zoom:11,//级别
    //         center: [116.397428, 39.90923],//中心点坐标
    //         viewMode:'3D'//使用3D视图
    //     });
  },

  methods: {
    init() {
      let map = new AMap.Map("container", {
        resizeEnable: true,
        rotateEnable: true,
        pitchEnable: true,
        zoom: 17,
        pitch: 80,
        rotation: -15,
        viewMode: "3D", //开启3D视图,默认为关闭
        buildingAnimation: true, //楼块出现是否带动画
        expandZoomRange: true,
        zooms: [3, 20],
        center: [121.5273285, 31.21315058],
      });
      marker = new AMap.Marker({
        position: [121.5273285, 31.21315058],
        // icon: "https://webapi.amap.com/images/car.png",
        icon:'/public/favicon.ico',
        //坐标偏移
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        angle: -90,
        map: map,
      });
      var polyline = new AMap.Polyline({
        map: this.map,
        //这里替换自己的坐标数据
        path: lineArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 6, //线宽
        strokeStyle: "solid", //线样式
      });
    },
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.mapDiv {
  width: 100%;
  height: 800px;
}
</style>
